import { HttpClient } from '@/shared/lib/http-client';

export const setupPassword = async({ email, token, password }) => {
  const response = await HttpClient.post('/auth/setup-password', {
    email,
    token,
    password,
    password_confirmation: password,
  });

  return response.data?.data;
};
